import { render, staticRenderFns } from "./WeightValidation.vue?vue&type=template&id=f6fcc186&scoped=true&"
import script from "./WeightValidation.vue?vue&type=script&lang=js&"
export * from "./WeightValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fcc186",
  null
  
)

export default component.exports